import React from "react";
import "./Requirements.css";
import { useTranslation } from "react-i18next";

const XPORequirements = () => {
  const { t } = useTranslation("settings");
  return (
    <div className="cuscarrier__reqrmnts_box">
      {t("carriers.custom.requirements.xpo")}
    </div>
  );
};

export default XPORequirements;
